import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;

    & > img {
        height: 40px;
        border: solid 1px black;
        margin: 4px;
        border-radius: 4px;
    }

`;
export const Wrapper1 = styled.div`

`;
